// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"4d843ce2","787":"a6bf8f17"}[chunkId] + ".chunk.js";
};